// Morgan State's undergraduate majors (#2743). Read on 2026-10-01 from the
// official 2026-2028 Undergraduate Catalog (catalog.morgan.edu, catoid=28):
// each school or college page lists its departments' programs under degree
// headings; every bachelor's program kept with the degree the catalog gives
// ("Economics, B.A. or B.S."). Left out: minors, certificates, the honors
// versions of majors (each "X Honors Program" is a track of a major already
// listed), combined bachelor's and master's programs (B.S./M.E., B.S./M.Eng,
// the M.A.T.), the Online MLT to MLS degree-completion program, Military
// Science and the Pre-Law sequence. The catalog server answered scripted
// requests with an empty page, so it was read in a browser (Playwright). The
// official major name "Artificial Intelligence" is kept as written. The KB's
// majors list was the starting point; the catalog wins.
const majors = {
    "slug": "morgan-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Morgan State's official 2026-2028 Undergraduate Catalog, grouped by the school or college that offers it, with the degree it leads to. Honors tracks, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "James H. Gilliam Jr. College of Liberal Arts",
            "source": {
                "label": "Morgan State 2026-2028 Undergraduate Catalog, James H. Gilliam Jr. College of Liberal Arts",
                "url": "https://catalog.morgan.edu/content.php?catoid=28&navoid=2060"
            },
            "majors": [
                {
                    "name": "Applied Liberal Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A. or B.S."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Fine Art",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Musical Theatre",
                    "degree": "B.F.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Screenwriting and Animation (SWAN)",
                    "degree": "B.A. or B.F.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre Arts",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Interdisciplinary and Continuing Studies",
            "source": {
                "label": "Morgan State 2026-2028 Undergraduate Catalog, College of Interdisciplinary and Continuing Studies",
                "url": "https://catalog.morgan.edu/content.php?catoid=28&navoid=2081"
            },
            "majors": [
                {
                    "name": "Interdisciplinary Educational Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Engineering, Information, and Computational Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Global Perspectives and Practices",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Health and Human Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Organizational Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Studies in Societal Equity, and Urbanism",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Technology Services",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Global Journalism and Communication",
            "source": {
                "label": "Morgan State 2026-2028 Undergraduate Catalog, School of Global Journalism and Communication",
                "url": "https://catalog.morgan.edu/content.php?catoid=28&navoid=2061"
            },
            "majors": [
                {
                    "name": "Multimedia Journalism",
                    "degree": "B.S."
                },
                {
                    "name": "Multiplatform Production",
                    "degree": "B.S."
                },
                {
                    "name": "Strategic Communication",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Architecture and Planning",
            "source": {
                "label": "Morgan State 2026-2028 Undergraduate Catalog, School of Architecture and Planning",
                "url": "https://catalog.morgan.edu/content.php?catoid=28&navoid=2062"
            },
            "majors": [
                {
                    "name": "Architecture and Environmental Design",
                    "degree": "B.S."
                },
                {
                    "name": "Construction Management",
                    "degree": "B.S."
                },
                {
                    "name": "Interior Design",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Earl G. Graves School of Business and Management",
            "source": {
                "label": "Morgan State 2026-2028 Undergraduate Catalog, Earl G. Graves School of Business and Management",
                "url": "https://catalog.morgan.edu/content.php?catoid=28&navoid=2063"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S."
                },
                {
                    "name": "Cybersecurity Intelligence Management",
                    "degree": "B.S."
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "B.S."
                },
                {
                    "name": "Finance",
                    "degree": "B.S."
                },
                {
                    "name": "Hospitality Management",
                    "degree": "B.S."
                },
                {
                    "name": "Human Resource Management",
                    "degree": "B.S."
                },
                {
                    "name": "Information Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Management and Business Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S."
                },
                {
                    "name": "Services and Supply Chain Management",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Community Health and Policy",
            "source": {
                "label": "Morgan State 2026-2028 Undergraduate Catalog, School of Community Health and Policy",
                "url": "https://catalog.morgan.edu/content.php?catoid=28&navoid=2064"
            },
            "majors": [
                {
                    "name": "Health Education",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S."
                },
                {
                    "name": "Nutritional Science",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Computer, Mathematical, and Natural Sciences",
            "source": {
                "label": "Morgan State 2026-2028 Undergraduate Catalog, School of Computer, Mathematical, and Natural Sciences",
                "url": "https://catalog.morgan.edu/content.php?catoid=28&navoid=2065"
            },
            "majors": [
                {
                    "name": "Actuarial Science",
                    "degree": "B.S."
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Coastal Science and Policy",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Education and Urban Studies",
            "source": {
                "label": "Morgan State 2026-2028 Undergraduate Catalog, School of Education and Urban Studies",
                "url": "https://catalog.morgan.edu/content.php?catoid=28&navoid=2066"
            },
            "majors": [
                {
                    "name": "Elementary Education (Grades 1-6)",
                    "degree": "B.S."
                },
                {
                    "name": "Family and Consumer Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Sports Administration and Movement Education",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Engineering",
            "source": {
                "label": "Morgan State 2026-2028 Undergraduate Catalog, School of Engineering",
                "url": "https://catalog.morgan.edu/content.php?catoid=28&navoid=2067"
            },
            "majors": [
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechatronic Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Sustainable Urban Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Transportation Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Transportation Systems Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Social Work",
            "source": {
                "label": "Morgan State 2026-2028 Undergraduate Catalog, School of Social Work",
                "url": "https://catalog.morgan.edu/content.php?catoid=28&navoid=2068"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "B.S.W."
                }
            ]
        }
    ]
};

export default majors;
